<div class="container" *ngIf="!mediaclip?.id || mediaclip?.sourcetype === 'on_demand'">
	<div class="info">
		<div class="header">
			<h3>
				{{ uploadText(true) }}
			</h3>
		</div>
		<div class="replace-buttons">
			<div>
				<bb-upload
					[validateBeforeUpload]="checkYoutubeExport"
					[disabled]="uploading"
					[mediaclip]="mediaclip"
					[hideDropText]="true"
					[uploadText]="uploadText()"
					[removeMediaclipOnCancel]="false"
					[multi]="false"
					>
				</bb-upload>
			</div>
			<ng-container *ngIf="mediaclip?.assets?.length && mediaclip?.mediatype !== 'image'">
				<bb-button class="trim-button" type="icon-button" icon="cut" (click)="onTrimClick()">
					{{ 'TRIM' | translate }}
				</bb-button>
			</ng-container>
		</div>

		<ng-template #trimTemplate>
			<bb-trim
				style="display: block; min-width: 700px; width: 75vw; max-width: 90vh;"
				(trimchange)="onTrimchange($event)"
				(onSave)="onTrimSave($event)"
				(onCancel)="onTrimCancel($event)"
				[mediaclip]="mediaclip">
			</bb-trim>
		</ng-template>
		<p *ngIf="mediaclip?.mediatype === 'image'">{{ 'HELP.REPLACE_IMAGE' | translate }}</p>
		<p *ngIf="mediaclip?.mediatype !== 'image' && mediaclip?.assets?.length">{{ 'HELP.TRIM_REPLACE_' + (mediaclip?.mediatype ? mediaclip?.mediatype.toUpperCase() : 'VIDEO') | translate }}</p>
	</div>

	<div *ngIf="mediaclip?.id && !mediaclip?.isEmpty" class="info">
		<div class="header">
			<h3>
				{{ 'SOURCE_FILE' | translate }}
			</h3>
			<div class="specification">
				<div class="label">{{ 'FILENAME' | translate }}</div><div>{{ mediaclip?.originalfilename }}</div>
			</div>
			<div *ngIf="importedMediaclip" class="specification">
					<div class="label">{{ 'IMPORTED_FROM' | translate }}</div>
					<div class="ellipsis">
						<a [href]="importedMediaclipUrl">{{ importedMediaclipUrl }}</a>
					</div>
			</div>
			<div class="specification">
				<div class="label">{{ 'URL' | translate }}</div>
				<div class="ellipsis">
					<a [href]="processedSrc">{{ processedSrc }}</a>
				</div>
			</div>
			<div class="mediaclip-actions">
				<a class="button" [href]="processedSrc" target="_blank"><span><i class="fa fa-download"></i>{{ 'DOWNLOAD_SOURCE' | translate }}</span></a>
				<span class="button" (click)="showTechnicalInfo()"><i class="fa fa-info"></i>{{ 'TECHNICAL_INFO' | translate }}</span>
				<span class="button" (click)="copyUrlToClipboard(processedSrc)" ><i class="fa fa-copy"></i>{{ 'COPY_TO_CLIPBOARD' | translate }}</span>
				<span class="button"
					(click)="startHlsTransmuxing()"
					*ngIf="mediaclip?.sourceid?.startsWith('live_rec_')"
					[class.disabled]="mediaclip?.hasRunningJobs || hasMp4Asset"
				><i class="fa fa-plus"></i>{{ 'GENERATE_MP4' | translate }}
				</span>
			</div>
		</div>
	</div>
</div>

<div class="livestream-message">
	<span *ngIf="mediaclip?.sourcetype === 'live'" [innerHTML]="'HELP.MEDIACLIP_LIVESTREAM' | translate"></span>
</div>

<span *ngIf="mediaclip?.hasRunningJobs && mediaclip?.mediatype !== 'image'" class="message warning ng-binding">
	{{ 'TRANSCODING_NOT_YET_FINISHED' | translate:translations }}
</span>

<!-- assets / streams -->
<div *ngIf="mediaclip?.mediatype !== 'image'">
	<div class="header">
		<h3>
			{{ (mediaclip?.sourcetype === 'live' ? 'STREAMS' : 'ASSETS') | translate }}
		</h3>
	</div>

	<div class="header">
		<div class="button" (click)="addNewAsset()">
			<i class="fa fa-plus"></i>
			{{ (mediaclip && mediaclip.sourcetype === 'live' ? 'ADD_NEW_STREAM' : 'ADD_NEW_ASSET') | translate }}
		</div>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="hide-on-mobile" property="assetType">{{ 'ASSET_TYPE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="label">{{ 'LABEL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="url" class="overflow">{{ 'URL' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="width">{{ 'WIDTH' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="height">{{ 'HEIGHT' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="hide-on-mobile" property="bitrate">{{ 'BITRATE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngIf="assetRows?.length === 0">
			<bb-table-cell property="assetType" class="overflow"><span>{{ 'NO_ASSETS_YET' | translate }}</span></bb-table-cell>
			<bb-table-cell class="hide-on-mobile" property="status">&nbsp;</bb-table-cell>
			<bb-table-cell property="status">&nbsp;</bb-table-cell>
			<bb-table-cell property="status">&nbsp;</bb-table-cell>
			<bb-table-cell property="status">&nbsp;</bb-table-cell>
			<bb-table-cell property="status">&nbsp;</bb-table-cell>
			<bb-table-cell class="hide-on-mobile" property="status">&nbsp;</bb-table-cell>
			<bb-table-cell property="status">&nbsp;</bb-table-cell>
		</bb-table-row>

		<bb-table-row *ngFor="let row of assetRows; let i = index; trackBy: trackBy" [row]="row" [colspan]="9">
			<bb-table-cell class="hide-on-mobile" property="assetType"><span>{{ row?.data?.mediatype }}</span></bb-table-cell>
			<bb-table-cell property="label"><span>{{ row?.title }}</span></bb-table-cell>
			<bb-table-cell property="url" class="overflow">
				<a *ngIf="row?.data?.mediatype !== 'MP4_HLS' && row?.data?.mediatype !== 'MPD'" [href]="row?.src" target="_blank">{{ row?.src }}</a>
				<span *ngIf="row?.data?.mediatype === 'MP4_HLS' || row?.data?.mediatype === 'MPD'">{{ row?.src }}</span>
			</bb-table-cell>
			<bb-table-cell property="width"><span>{{ row?.data?.width }}</span></bb-table-cell>
			<bb-table-cell property="height"><span>{{ row?.data?.height }}</span></bb-table-cell>
			<bb-table-cell class="hide-on-mobile" property="bitrate"><span>{{ (row?.data?.mediatype === 'MP4_HLS' || row?.data?.mediatype === 'MPD' ? 'ADAPTIVE' : row?.data?.bandwidth + ' kbps') | translate }}</span></bb-table-cell>
			<bb-table-cell property="status" [ngClass]="{'status': row?.data?.status}"><span [innerHTML]="row?.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [class.disabled]="row?.id === 'new' || row?.data?.status !== 'active' || row?.data?.mediatype === 'MP4_TIMELINE'" (click)="showPreview(row?.data?.id)">
						<i class="fa fa-eye"></i>
				</a><!--

				--><a class="button" [class.disabled]="row?.id === 'new' || row?.data?.mediatype === 'MP4_HLS' || row?.data?.mediatype === 'MPD'" (click)="downloadAsset(row?.src, $event)">
					<i class="fa fa-download"></i>
				</a><!--
				--><a class="button" [class.disabled]="row?.id === 'new'" (click)="copyUrlToClipboard(row?.src)">
					<i class="fa fa-copy"></i>
				</a><!--
				--><a class="button" [class.disabled]="row?.id === 'new' || row?.data?.isSource" [class.active]="row?.quickEditing" (click)="row.quickEditing = ! row.quickEditing">
					<i class="fa fa-pencil"></i>
				</a>
				
			</bb-table-cell>
			<div quickedit>
				<asset-quickedit [mediaclipType]="mediaclip?.mediatype" [row]="row" [mediaFormats]="mediaFormats" *ngIf="row?.quickEditing" (canceled)="onAssetCanceled($event, assetRows, i)" (removed)="onItemRemoved(assetRows, i)" (saved)="onAssetSaved($event, assetRows, i)">
				</asset-quickedit>
			</div>
		</bb-table-row>

	</bb-table-container>

	<bb-table-pager [total]="mediaclip?.assets?.length" (pageNumber)="assetPageChanged($event)"></bb-table-pager>
</div>
